// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-agenda--element {
  background-color: var(--agenda-bg-color);
}
.block-agenda--element .block-agenda__title {
  color: var(--sections-title-color) !important;
}
.block-agenda--element .agenda-card__title,
.block-agenda--element .agenda-card__nested-title {
  color: var(--agenda-title-color) !important;
}
.block-agenda--element .agenda-card__paragraph,
.block-agenda--element .agenda-card__speakers-container-label {
  color: var(--agenda-description-color) !important;
}
.block-agenda--element .agenda-card__content {
  background-color: var(--agenda-card-bg-color) !important;
  border-right: 0;
  background-color: var(--agenda-card-bg-color) !important;
  border-top: 1px solid var(--default-border-color) !important;
  border-bottom: 1px solid var(--default-border-color) !important;
  border-left: 0;
}
.block-agenda--element .agenda-card__collapsible {
  background-color: var(--agenda-card-bg-color) !important;
  border: 1px solid var(--default-border-color) !important;
}
.block-agenda--element .agenda-card__time {
  color: var(--agenda-time-color) !important;
}
.block-agenda--element .agenda-card__timing {
  color: var(--agenda-timing-color) !important;
  font-weight: var(--agenda-timing-font-weight) !important;
}
.block-agenda--element .agenda-card__speaker .ant-card-meta-title {
  color: var(--agenda-speaker-text-color) !important;
  font-weight: 500;
}
.block-agenda--element .agenda-card__speaker .ant-card-meta-avatar {
  padding-right: 10px;
}
.block-agenda--element .block-agenda__tabs-container .ant-tabs-tab {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, padding 0.2s ease;
}
.block-agenda--element .block-agenda__tabs-container.fixedTabs {
  margin: 0 !important;
  background-color: var(--agenda-bg-color);
  z-index: 1;
  position: sticky;
  top: calc(var(--navbar-height-mobile));
  display: flex;
  align-items: center;
  padding: 10px 0px;
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__tabs-container.fixedTabs {
    top: calc(var(--navbar-height-desktop));
  }
}
.block-agenda--element .block-agenda__tabs-container--hide-xs {
  display: none;
}
@media (min-width: 992px) {
  .block-agenda--element .block-agenda__tabs-container--hide-lg {
    display: none;
  }
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__tabs-container--hide-xl {
    display: none;
  }
}
.block-agenda--element .agenda-card__collapsible .ant-collapse-expand-icon,
.block-agenda--element .agenda-card__collapsible .ant-collapse-expand-icon span {
  font-size: 14px !important;
  color: var(--agenda-title-color) !important;
}
.block-agenda--element .agenda-card__collapsible .ant-collapse-header {
  padding: var(--agenda-card-padding) !important;
}
.block-agenda--element .agenda-card__collapsible .ant-collapse-item {
  border-bottom: 0;
}
.block-agenda--element .agenda-card__collapsible .ant-collapse-content-box {
  padding: var(--agenda-card-padding) !important;
}
.block-agenda--element {
  /* === START AGENDA COLUMNS ==== */
}
.block-agenda--element .block-agenda__agenda-columns {
  display: none;
}
.block-agenda--element .block-agenda__agenda-columns--show-xs {
  display: block;
}
@media (min-width: 992px) {
  .block-agenda--element .block-agenda__agenda-columns--show-lg {
    display: block;
  }
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__agenda-columns--show-xl {
    display: block;
  }
}
.block-agenda--element .block-agenda__column-title {
  color: var(--sections-title-color) !important;
  margin: 0 !important;
  padding: 20px;
  background-color: var(--agenda-bg-color);
  z-index: 1;
  position: sticky;
  top: calc(var(--navbar-height-mobile));
  border-bottom: 1px solid var(--default-border-color);
  margin-bottom: 30px !important;
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__column-title {
    top: calc(var(--navbar-height-desktop));
  }
}
.block-agenda--element {
  /* === START AGENDA TABLE ==== */
}
.block-agenda--element .block-agenda__agenda-table {
  display: none;
  margin-top: -10px;
}
.block-agenda--element .block-agenda__agenda-table--show-xs {
  display: block;
}
@media (min-width: 992px) {
  .block-agenda--element .block-agenda__agenda-table--show-lg {
    display: block;
  }
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__agenda-table--show-xl {
    display: block;
  }
}
.block-agenda--element .block-agenda__agenda-table .ant-col .ant-col:first-of-type {
  margin-top: 30px;
}
.block-agenda--element .block-agenda__agenda-table.reducedMargin .ant-col .ant-col {
  margin-top: 0px;
}
.block-agenda--element .block-agenda__agenda-table .agenda-column {
  scroll-margin: 5rem;
}
.block-agenda--element .block-agenda__table-title {
  margin: 0 !important;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title {
    padding-right: 30px;
  }
}
.block-agenda--element .block-agenda__table-title .ant-tag {
  font-size: 16px;
  padding: 7px;
  white-space: initial !important;
  color: var(--sections-title-color) !important;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title .ant-tag {
    font-size: 18px;
  }
}
.block-agenda--element .block-agenda__table-title-content {
  margin: 0 !important;
  padding: 20px 0px;
  background-color: var(--agenda-bg-color);
  z-index: 1;
  position: sticky;
  top: calc(var(--navbar-height-mobile));
  border-bottom: 1px solid var(--default-border-color);
  display: flex;
  align-items: center;
}
@media (min-width: 1200px) {
  .block-agenda--element .block-agenda__table-title-content {
    top: calc(var(--navbar-height-desktop));
  }
}
.block-agenda--element .block-agenda__table-title-content.notSticky {
  position: relative;
  top: 0;
  z-index: 0;
}
.block-agenda--element .block-agenda__table-title-content > *:nth-child(1) {
  flex-basis: 100%;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title-content > *:nth-child(1) {
    display: block;
    flex-basis: 55%;
  }
}
.block-agenda--element .block-agenda__table-title-content > *:nth-child(2) {
  display: none;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title-content > *:nth-child(2) {
    display: block;
    flex-basis: 20%;
  }
}
.block-agenda--element .block-agenda__table-title-content > *:nth-child(3) {
  display: none;
}
@media (min-width: 768px) {
  .block-agenda--element .block-agenda__table-title-content > *:nth-child(3) {
    display: block;
    flex-basis: 25%;
  }
}
.block-agenda--element .block-agenda__table-title-timings {
  color: var(--sections-title-color) !important;
  font-weight: 600;
  font-size: 17px;
}
.block-agenda--element .block-agenda__table-title-speakers {
  color: var(--sections-title-color) !important;
  font-weight: 600;
  font-size: 17px;
}
.block-agenda--drawer {
  background-color: var(--agenda-drawer-bg-color);
}
.block-agenda--drawer .agenda-card__title {
  font-size: 18px !important;
}
@media (min-width: 992px) {
  .block-agenda--drawer .agenda-card__title {
    font-size: 20px !important;
  }
}
.block-agenda--drawer .agenda-card__title,
.block-agenda--drawer .agenda-card__nested-title {
  color: var(--agenda-drawer-title-color) !important;
}
.block-agenda--drawer .agenda-card__paragraph,
.block-agenda--drawer .agenda-card__speakers-container-label {
  color: var(--agenda-drawer-title-color) !important;
}
.block-agenda--drawer .agenda-card__collapsible {
  background-color: transparent !important;
}
.block-agenda--drawer .agenda-card__time {
  color: var(--agenda-drawer-time-color);
}
.block-agenda--drawer .agenda-card__timing {
  color: var(--agenda-drawer-time-color);
}
.block-agenda--drawer .agenda-card__speaker .ant-card-meta-title {
  color: var(--agenda-drawer-speaker-name-color) !important;
  font-weight: 500;
}
.block-agenda--drawer .agenda-card__speaker .ant-card-meta-avatar {
  padding-right: 10px;
}
.block-agenda--drawer .agenda-card__wrapper {
  padding: 10px 0 30px !important;
}
.block-agenda--drawer .agenda-card__collapsible .ant-collapse-header {
  padding: 10px 0 30px !important;
}
.block-agenda--drawer .agenda-card__collapsible .ant-collapse-expand-icon,
.block-agenda--drawer .agenda-card__collapsible .ant-collapse-expand-icon span {
  font-size: 16px;
  color: var(--agenda-title-color) !important;
}
.block-agenda--drawer .agenda-card__content--list-item {
  border-radius: 0px;
  border-bottom: 1px solid var(--default-border-color);
}
.block-agenda .episode-details {
  margin-bottom: 3em;
}
.block-agenda .block-agenda__episode-speakers {
  margin-bottom: 2em;
}

.agenda-table-col-item .ant-collapse-expand-icon {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Agenda/Agenda.scss"],"names":[],"mappings":"AAGI;EACI,wCAAA;AAFR;AAIQ;EACI,6CAAA;AAFZ;AAKQ;;EAEI,2CAAA;AAHZ;AAMQ;;EAEI,iDAAA;AAJZ;AAOQ;EACI,wDAAA;EAEA,eAAA;EACA,wDAAA;EACA,4DAAA;EACA,+DAAA;EACA,cAAA;AANZ;AASQ;EACI,wDAAA;EACA,wDAAA;AAPZ;AAUQ;EACI,0CAAA;AARZ;AAWQ;EACI,4CAAA;EACA,wDAAA;AATZ;AAYQ;EACI,kDAAA;EACA,gBAAA;AAVZ;AAaQ;EACI,mBAAA;AAXZ;AAiBY;EACI,kGACI;AAhBpB;AAsBY;EACI,oBAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AApBhB;AAsBgB;EAVJ;IAWQ,uCAAA;EAnBlB;AACF;AAsBY;EACI,aAAA;AApBhB;AAwBgB;EADJ;IAEQ,aAAA;EArBlB;AACF;AAyBgB;EADJ;IAEQ,aAAA;EAtBlB;AACF;AA2BY;;EAEI,0BAAA;EACA,2CAAA;AAzBhB;AA4BY;EACI,8CAAA;AA1BhB;AA6BY;EACI,gBAAA;AA3BhB;AA8BY;EACI,8CAAA;AA5BhB;AAjFI;EAiHI,kCAAA;AA7BR;AA8BQ;EACI,aAAA;AA5BZ;AA8BY;EACI,cAAA;AA5BhB;AAgCgB;EADJ;IAEQ,cAAA;EA7BlB;AACF;AAiCgB;EADJ;IAEQ,cAAA;EA9BlB;AACF;AAkCQ;EACI,6CAAA;EACA,oBAAA;EACA,aAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,sCAAA;EACA,oDAAA;EACA,8BAAA;AAhCZ;AAkCY;EAXJ;IAYQ,uCAAA;EA/Bd;AACF;AApHI;EAsJI,gCAAA;AA/BR;AAgCQ;EACI,aAAA;EACA,iBAAA;AA9BZ;AAgCY;EACI,cAAA;AA9BhB;AAkCgB;EADJ;IAEQ,cAAA;EA/BlB;AACF;AAmCgB;EADJ;IAEQ,cAAA;EAhClB;AACF;AAoCY;EACI,gBAAA;AAlChB;AAsCgB;EACI,eAAA;AApCpB;AAwCY;EACI,mBAAA;AAtChB;AA0CQ;EACI,oBAAA;AAxCZ;AA0CY;EAHJ;IAIQ,mBAAA;EAvCd;AACF;AAyCY;EACI,eAAA;EACA,YAAA;EACA,+BAAA;EACA,6CAAA;AAvChB;AAyCgB;EANJ;IAOQ,eAAA;EAtClB;AACF;AA0CQ;EACI,oBAAA;EACA,iBAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,sCAAA;EACA,oDAAA;EACA,aAAA;EACA,mBAAA;AAxCZ;AA0CY;EAXJ;IAYQ,uCAAA;EAvCd;AACF;AAyCY;EACI,kBAAA;EACA,MAAA;EACA,UAAA;AAvChB;AA0CY;EACI,gBAAA;AAxChB;AA0CgB;EAHJ;IAIQ,cAAA;IACA,eAAA;EAvClB;AACF;AA0CY;EACI,aAAA;AAxChB;AA0CgB;EAHJ;IAIQ,cAAA;IACA,eAAA;EAvClB;AACF;AA0CY;EACI,aAAA;AAxChB;AA0CgB;EAHJ;IAIQ,cAAA;IACA,eAAA;EAvClB;AACF;AA2CQ;EACI,6CAAA;EACA,gBAAA;EACA,eAAA;AAzCZ;AA4CQ;EACI,6CAAA;EACA,gBAAA;EACA,eAAA;AA1CZ;AA8CI;EACI,+CAAA;AA5CR;AA8CQ;EACI,0BAAA;AA5CZ;AA8CY;EAHJ;IAIQ,0BAAA;EA3Cd;AACF;AA8CQ;;EAEI,kDAAA;AA5CZ;AA+CQ;;EAEI,kDAAA;AA7CZ;AAgDQ;EACI,wCAAA;AA9CZ;AAiDQ;EACI,sCAAA;AA/CZ;AAkDQ;EACI,sCAAA;AAhDZ;AAmDQ;EACI,yDAAA;EACA,gBAAA;AAjDZ;AAoDQ;EACI,mBAAA;AAlDZ;AAqDQ;EACI,+BAAA;AAnDZ;AAuDY;EACI,+BAAA;AArDhB;AAwDY;;EAEI,eAAA;EACA,2CAAA;AAtDhB;AA0DQ;EACI,kBAAA;EACA,oDAAA;AAxDZ;AA4DI;EACI,kBAAA;AA1DR;AA6DI;EACI,kBAAA;AA3DR;;AAgEI;EACI,wBAAA;AA7DR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
